import React from "react";

const Settings: React.FC = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
        Settings
      </h1>
      <div className="text-center py-12">
        <p className="text-gray-500 dark:text-gray-400">
          Settings page coming soon...
        </p>
      </div>
    </div>
  );
};

export default Settings;
